import React, { useEffect, useState } from "react";
import { Container, Content, FlexboxGrid, Header } from "rsuite";
import { useRouteMatch, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { getRegistrationCount } from "actions/registration";
import { APP_TYPE_CLIENT, APP_TYPE_DEFAULT } from "const";
import { pageIdLogObject } from "utils/pageIdLogger";
import { logoutUser } from "actions/auth";
import { useWindowWidth } from "hooks";
import {
    getRealtimePaymentStatus,
    modifyAccountRequest,
    openAllocationModal,
} from "actions";
import VersionLabel from "components/VersionLabel/VersionLabel";
import ContentLoader from "components/ContentLoader";
import Menu from "components/Navigation/Navigation";
import NumberAllocation from "pages/NumberAllocation";
import RulesRegulationWidget from "./RulesRegulationWidget";
import ShowWidgetsButton from "./ShowWidgetsButton";
import ManualWidget from "./ManualWidget";
import TeamsWidget from "./TeamsWidget";
import ErrorBoundary from "./Error";


const Layout = ({
    showModalInterface,
    showModalColor,
    logoutUser,
    openAllocationModal,
    method_list,
    modifyAccountRequest,
    modifyPasswordRequest,
    getRegistrationCount,
    getRealtimePaymentStatus,
    accountInfo,
    service,
    error,
    roles,
    authInfo,
    errorMessage,

    pageId,
    appType,
    lang,
    rtl,

    ...props
}) => {

    const windowWidth = useWindowWidth();
    const routeMatch = useRouteMatch();

    const location = useLocation();

    const [showWidgets, setShowWidgets] = useState(false);
    const isTest = authInfo?.session?.is_test;

    // set logger
    if (routeMatch.path === "/" && routeMatch.path !== location.pathname) {
        routeMatch.path = location.pathname;
        routeMatch.url = location.pathname;
    }

    const pageMatch = {
        ...routeMatch,
        path: pageId || routeMatch.path,
    };
    pageIdLogObject.pageMatch = pageMatch;

    // set rtl DOM
    useEffect(() => {
        if (APP_TYPE_DEFAULT !== APP_TYPE_CLIENT) {
            return;
        }

        if (rtl && !["/reset-password"].includes(routeMatch.path)) {
            document.body.classList.add("rtl");
        } else {
            document.body.classList.remove("rtl");
        }

    }, [rtl, lang, routeMatch]);

    return (
        <Container style={{ minHeight: "100vh" }}>
            <Header>
                <Menu {...{
                    logoutUser,
                    openAllocationModal,
                    method_list,
                    modifyAccountRequest,
                    modifyPasswordRequest,
                    getRegistrationCount,
                    getRealtimePaymentStatus,
                    accountInfo,
                    service,
                    error,
                    roles,
                    errorMessage
                }} />
                <NumberAllocation pageMatch={pageMatch} />
            </Header>
            <Content>
                <FlexboxGrid justify="center">
                    <FlexboxGrid.Item colspan={windowWidth < 768 ? 24 : 22}>
                        <ErrorBoundary>
                            {props.children}
                        </ErrorBoundary>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </Content>
            <ContentLoader service={service} />
            <RulesRegulationWidget />
            <VersionLabel />
            {!isTest && <>
                {appType === APP_TYPE_CLIENT && <ShowWidgetsButton show={showWidgets} setShow={setShowWidgets} />}
                {showWidgets
                    ? <>
                        <TeamsWidget />
                        {appType === APP_TYPE_CLIENT && <ManualWidget />}
                    </>
                    : <></>
                }
            </>}
        </Container>
    );
};

const mapState = ({ auth, references, accounts, roles }) => ({
    authInfo: auth.authInfo,
    service: auth.service,
    appType: auth.appType,
    lang: auth.lang,
    rtl: auth.rtl,
    roles: roles.role_list,
    method_list: references.method_list,
    accountInfo: accounts.accountInfo,
    error: accounts.editError,
    errorMessage: accounts.editErrorMessage
});

export default connect(mapState, {
    openAllocationModal,
    logoutUser,
    modifyAccountRequest,
    getRegistrationCount,
    getRealtimePaymentStatus,
})(Layout);